import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        fetch({commit, dispatch}) {
            return new Promise((resolve, reject) => {
                commit('TOGGLE_PRELOADER', true, {root: true})
                axios.get(
                    '/api/restaurant-manager/services/list'
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                    reject(error)
                }).finally(() => {
                    commit('TOGGLE_PRELOADER', false, {root: true})
                })
            })
        },
        add({commit, dispatch}, payload) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/restaurant-manager/services/add',
                    prepareData(payload)
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/restaurant-manager/services/edit/' + editedItem.id,
                    prepareData(editedItem)
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({commit, dispatch}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/restaurant-manager/services/dell/' + itemId
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}

function prepareData (data) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('name', data.name)
    fd.append('intro', data.intro)
    fd.append('price', data.price)
    if (data.description) {
        fd.append('description', data.description)
    }
    fd.append('published', Number(data.published))
    fd.append('restaurant_id', Number(data.restaurant_id))

    return fd
}
